export const FETCH_TRAIT_SUCCESS = 'FETCH_TRAIT_SUCCESS';
export const FETCH_TRAIT_REQUEST = 'FETCH_TRAIT_REQUEST';
export const FETCH_TRAIT_FAILURE = 'FETCH_TRAIT_FAILURE';